import { isWebPushTransportEnabled } from "@/lib/isWebPushTransportEnabled";
import type { WebPushCapability } from "@/lib/web-push-browser";

interface WebPushConfig {
  available?: boolean;
  publicKey?: string | null;
  transports?: { apns: boolean; fcm: boolean };
}

/** Includes the configured iOS installation journey as well as directly supported browsers. */
export function isWebPushJourneyAvailable(
  capability: WebPushCapability | null,
  config: WebPushConfig | undefined,
) {
  if (!capability || capability.kind === "unsupported" || !config?.available || !config.publicKey) {
    return false;
  }
  return isWebPushTransportEnabled(config.transports, capability.transport);
}
